<template>
	<div class="profile">
		<label for="profile-type">Type: </label>
		<select class="custom-select col-md-3" v-model="profile_type" id="profile-type">
			<option value="b2c">B2C</option>
			<option value="b2b">B2B</option>
		</select>
		<div v-if="profile_type === 'b2c'">

		</div>
		<div v-else>
			<p class="label">B2B / Reseller</p>
			<div class="form-wrapper">
				<div class="row">
					<div class="form-group col-md-6 input-extra">
						<input type="text" class="form-control" id="b2b_company" placeholder="Company/School/Studio name" v-model="form.b2b_company" name="b2b_company">
						<label for="b2b_company">Company/School/Studio name</label>
					</div>
					<div class="form-group col-md-6 input-extra">
						<input type="text" class="form-control" id="b2b_company_address" placeholder="Address"  v-model="form.b2b_company_address" name="b2b_company_address">
						<label for="b2b_company_address">Address</label>
					</div>
					<div class="form-group col-md-6 input-extra">
						<input type="text" class="form-control" id="b2b_company_post" placeholder="Post code/Zip code"  v-model="form.b2b_company_post" name="b2b_company_post">
						<label for="b2b_company_post">Post code/Zip code</label>
					</div>
					<div class="form-group col-md-6 input-extra">
						<input type="text" class="form-control" id="b2b_company_city" placeholder="City"  v-model="form.b2b_company_city" name="b2b_company_city">
						<label for="b2b_company_city">City</label>
					</div>

					<div class="form-group col-md-6 input-extra">
						<input type="text" class="form-control" id="b2b_company_country" placeholder="Country"  v-model="form.b2b_company_country" name="b2b_company_country">
						<label for="b2b_company_country">Country</label>
					</div>
					<div class="form-group col-md-6 input-extra">
						<input type="text" class="form-control" id="b2b_company_region" placeholder="Website"  v-model="form.b2b_company_region" name="b2b_company_region">
						<label for="b2b_company_region">Region</label>
					</div>

					<div class="form-group col-md-6 input-extra">
						<input type="text" class="form-control" id="b2b_company_website" placeholder="Website"  v-model="form.b2b_company_website" name="b2b_company_website">
						<label for="b2b_company_website">Website</label>
					</div>
					<div class="form-group col-md-6 input-extra">
						<input type="text" class="form-control" id="b2b_company_email" placeholder="Website"  v-model="form.b2b_company_email" name="b2b_company_email">
						<label for="b2b_company_email">Email</label>
					</div>
					<div class="form-group col-md-6 input-extra">
						<input type="text" class="form-control" id="b2b_company_phone" placeholder="Telephone number"  v-model="form.b2b_company_phone" name="b2b_company_phone">
						<label for="b2b_company_phone">Telephone number</label>
					</div>
					<div class="form-group col-md-6 input-extra">
						<input type="text" class="form-control" id="b2b_company_mobile" placeholder="Mobile number"  v-model="form.b2b_company_mobile" name="b2b_company_mobile">
						<label for="b2b_company_mobile">Mobile number</label>
					</div>
					<div class="form-group col-md-6 input-extra">
						<input type="text" class="form-control" id="b2b_company_registration" placeholder="Registration number"  v-model="form.b2b_company_registration" name="b2b_company_registration">
						<label for="b2b_company_registration">Registration number</label>
					</div>
					<div class="form-group col-md-6 input-extra">
						<input type="text" class="form-control" id="b2b_company_vat" placeholder="VAT number"  v-model="form.b2b_company_vat" name="b2b_company_vat">
						<label for="b2b_company_vat">VAT number</label>
					</div>
					<div class="form-group">

						<div class="custom-control custom-checkbox">
							<input type="checkbox" class="custom-control-input" id="agreement-check" v-model="form.b2b_company_terms" :readonly="form.b2b_company_terms == 1">
							<label class="custom-control-label" for="agreement-check">{{ $__('checkout.agreement.prefix') }} <a :href="agreementurl" :title="$__('checkout.agreement.terms')" target="_blank" v-text="$__('checkout.agreement.terms')"></a> {{ $__('checkout.agreement.postfix') }}</label>
						</div>

					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ProfileForm',
	data() {
		return {
			opened: false,
			profile_type: 'b2c',
			form:  null
		}
	},
	props: {
		user: Object
	},
	methods: {
		updateProfile(e) {
			axios.post('/profile/update', {region: region})
				.then(response => {
					if (response.data.error === false) {
						location.reload()
					}
				})
				.catch(function (error) {
					// error
				})
		},
	},
	mounted () {
		// prevent click outside event with popupItem.
		this.form = this.user
		this.popupItem = this.$el
	},
}
</script>
